import * as React from 'react'
import { useCallback } from 'react'

import { useFormikContext } from 'formik'
import Box from '@mui/material/Box'

import { IReferral } from '@sales-center/common'
import { IAddOpportunityFormModel } from '../../../typings'
import {
  ReferralFormVariant,
  TidalUpdateReferral,
} from '@user/components/Referrals/components/UpdateReferral/TidalUpdateReferral'
import { ScrollToErrorMarker } from '@user/components/Formik/ScrollToErrorMarker'
import { ReferralsContextProvider } from '@user/components/Referrals/context'

type Props = {
  required: boolean
  show: boolean
  name: string
}

export function Referral(props: Props) {
  const { required, show, name } = props

  const { errors, setFieldValue, touched, values } =
    useFormikContext<IAddOpportunityFormModel>()

  const onChangeReferral = useCallback(
    (referral: IReferral) => {
      setFieldValue(name, referral)
    },
    [setFieldValue, name],
  )
  return show ? (
    <Box>
      <ReferralsContextProvider>
        <>
          <TidalUpdateReferral
            billToCardWidth="342px"
            disabled={false}
            entityErrors={errors}
            onChange={onChangeReferral}
            padding="0"
            referral={values.referral ?? undefined}
            required={required}
            salesTeamId={values.salesTeamId}
            title="Referral"
            touched={touched}
            name="referral"
            formVariant={ReferralFormVariant.Drawer}
          />
          <ScrollToErrorMarker fieldName={name} />
        </>
      </ReferralsContextProvider>
    </Box>
  ) : null
}
